module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "25%"
    }
  }, [(_vm.custom) ? _c('div', [_c('div', [_vm._t("default")], 2)]) : _c('div', [_c('div', {
    staticClass: "applet-menu-content",
    style: (_vm.customStyle)
  }, [_c('p', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "background": "#fff",
      "opacity": "0",
      "width": "100px",
      "height": "100px",
      "top": "0",
      "left": "0"
    }
  }, [_c('wx-open-launch-weapp', {
    attrs: {
      "id": "launch-btn",
      "appid": _vm.appid,
      "username": _vm.userName,
      "path": _vm.path
    },
    on: {
      "launch": _vm.handleLaunchFn,
      "error": _vm.handleErrorFn
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n          <style>\n          </style>\n          <div style=\"width: 100px; height: 100px; border: none; background: #fff;\"/>\n        ")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45fba9e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppletIconMenu.vue
// module id = 823
// module chunks = 0